/* eslint-disable no-tabs */
import styled from 'styled-components'

export const OutlineTable = styled.div`
  border: 2px solid var(--c2);
  padding: .75rem;
  border-radius: 4px;
  margin-top: .75rem;
	th {
		padding: .5rem 0 .5rem 0;
		font-size: 12px;
		font-weight: 700;
		color: #4A5568;
		:first-child{
			text-align: start;
			padding-left: 1.25rem;
		}
	}
	td {
		background-color: var(--AzulOpacoBg);
		border-bottom: 8px solid #fff;
		height: 68px;
		border-top: 3px solid #fff;
		:last-child {
			padding-top: 0;
			height: 0;
		}
	}
`
export const StyledSpan = styled.span`
	display: flex;
	align-items: center;
	color: var(--Gray1);
	font-weight: 400;
	justify-content: center;
	font-size: 12px;
	gap: .5rem;
`
